import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutDriverEventsQuickInfo extends Layout {
    sourceDriverEvents: DataSource;
    tableDriverEvents: Table;
}
